import { Theme } from '@mui/material/styles';

// Component styles
export const getResponsiveTypographyStyles = (theme: Theme) => ({
  title: {
    fontSize: {
      xs: theme.typography.pxToRem(24),
      md: theme.typography.pxToRem(36),
    },
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightLight,
    fontStyle: 'italic',
  },
  orderText: {
    color: theme.palette.common.white,
    fontWeight: 400,
    fontSize: {
      xs: theme.typography.pxToRem(12),
      md: theme.typography.pxToRem(14),
    },
  },
  description: {
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: {
      xs: theme.typography.pxToRem(18),
      md: theme.typography.pxToRem(20),
    },
  },
});

export const getButtonStyles = (theme: Theme) => ({
  downloadButton: {
    width: 'max-content',
    '& .MuiButton-startIcon > svg, & .MuiButton-endIcon > svg': {
      fill: theme.palette.common.white,
      stroke: theme.palette.common.white,
      fontSize: '16px',
    },
    '& .MuiButton-startIcon svg, & .MuiButton-endIcon svg': {
      stroke: theme.palette.text.opposite,
    },
  },
  platformButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    '& .MuiButton-startIcon > svg, & .MuiButton-endIcon > svg': {
      fill: theme.palette.common.white,
      stroke: theme.palette.common.white,
      fontSize: '16px',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.common.white,
      color: theme.palette.common.white,
      boxShadow: 'none',
    },
  },
});
